module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "tochead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap01"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("  1")]), _vm._v("The Genius of Gabriel Toller")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap02"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("  2")]), _vm._v("George Henry’s Black Eye")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap03"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("  3")]), _vm._v("Hand Over Mouth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("  4")]), _vm._v("All Shapes and Sizes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("  5")]), _vm._v("Mr. Rutter and Others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("  6")]), _vm._v("Enter Maurice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("  7")]), _vm._v("‘Tomorrow, Here’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("  8")]), _vm._v("Police for Polly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("  9")]), _vm._v("Gordon Craigie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("10")]), _vm._v("Beneath the Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("11")]), _vm._v("Landslide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("12")]), _vm._v("Monkey-tricks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("13")]), _vm._v("‘Chineside’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("14")]), _vm._v("The Hard Job")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("15")]), _vm._v("Paula Bentley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("16")]), _vm._v("More Moves in Bournemouth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("17")]), _vm._v("The Disappearance of ‘Thomas’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("18")]), _vm._v("Gertrude Ryall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("19")]), _vm._v("Power Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("20")]), _vm._v("Mr. Rutter’s Triumph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("21")]), _vm._v("Empty House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("22")]), _vm._v("The Triumph of George")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("23")]), _vm._v("The Professor with Nine Lives")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aa95e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 75
// module chunks = 0